export const ONE_DAY = '1 day';
export const ONE_WEEK = '1 week';
export const ONE_MONTH = '1 month';
export const THREE_MONTHS = '3 months';
